import { render, staticRenderFns } from "./ai-bot-chat-box.vue?vue&type=template&id=519fd8e3&"
import script from "./ai-bot-chat-box.vue?vue&type=script&lang=js&"
export * from "./ai-bot-chat-box.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports